import React, { useEffect, useState, useCallback, useRef } from "react";
import { ListSkeleton } from "../../skeletons/List";
import { AuthHelper } from "../../controllers/AuthHelper";
import FloatingActionButtons from "../../components/Fab";
import DirectorForm from "../../components/DirectorForm";
import { Checkbox, IconButton, Box, Typography, Drawer } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { register } from "swiper/element/bundle";
import { ServerConfig } from "../../../connectors/Config";

register();



const SingleCourse = React.memo(({ course, directors, assignCourseToDirector, refreshDirectors, onEdit }) => {
  return (
    <div style={{ maxWidth: 400, minHeight: 800, padding: "0 120px 48px" }}>
      <h2 style={{ textAlign: "left" }}>{course["nome corso"]}</h2>
      <div>
        {directors.map((director) => {
          const assigned = director.assignments?.some(x => x.course === course["id"]);
          return (
            <div key={director.id} style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Checkbox
                checked={!!assigned}
                onChange={() => assignCourseToDirector(course["id"], director.id)}
              />
              <h5 style={{ flex: 1, cursor: "pointer" }} onClick={() => onEdit(director)}>
                {director.name}
              </h5>
              <IconButton
                onClick={async () => {
                  try {
                    await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_2}/direttori/${director.id}`, { method: "DELETE" });
                   
                    refreshDirectors();
                  } catch {
                    alert("Errore server");
                  }
                }}
              >
                <Delete color="error" />
              </IconButton>
            </div>
          );
        })}
      </div>
    </div>
  );
});

const ListDirectors = () => {
  const [directors, setDirectors] = useState([]);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerTitle, setDrawerTitle] = useState("");
  const [drawerData, setDrawerData] = useState(null);
  const swiperRef = useRef(null);

  const getCurrentUser = useCallback(async () => {
    const apiKey = localStorage.getItem("cruddy-apiKey");
    const subCurrent = (await AuthHelper.getUserFromIdToken(apiKey)).Username;
    return subCurrent;
  }, []);

  const getDirectors = useCallback(async () => {
    const currentUser = await getCurrentUser();
    const res = await (await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/direttori/${currentUser}`)).json();
    setDirectors(Array.isArray(res) ? res : []);
    setLoading(false);
  }, [getCurrentUser]);

  const fetchCourses = useCallback(async () => {
    const res = await (await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/certificates`)).json();
    setCourses(Array.isArray(res) ? res : []);
  }, []);

  const assignCourseToDirector = useCallback(
    async (courseId, directorId) => {
      await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/direttori/assign/${directorId}`, {
        method: "PUT",
        body: JSON.stringify({ course: courseId, directors }),
        headers: { "Content-Type": "application/json" },
      });
      getDirectors();
    },
    [directors, getDirectors]
  );

  const handleCreate = useCallback(async () => {
    const currentUser = await getCurrentUser();
    setDrawerTitle("Crea Direttore");
    setDrawerData({ initialData: null, assigned: currentUser });
    setDrawerOpen(true);
  }, [getCurrentUser]);

  const handleEdit = useCallback(async (director) => {
    const currentUser = await getCurrentUser();
    setDrawerTitle("Modifica Direttore");
    setDrawerData({ initialData: director, assigned: currentUser });
    setDrawerOpen(true);
  }, [getCurrentUser]);

  useEffect(() => {
    getDirectors();
    fetchCourses();
  }, [getDirectors, fetchCourses]);

  return (
    <>
      {loading && <ListSkeleton />}
      {!loading && (
        <swiper-container slides-per-view="3" ref={swiperRef} virtual="true" navigation="true" style={{ paddingBottom: 320 }}>
          {courses.map(course => (
            <swiper-slide key={course.id}>
              <SingleCourse
                course={course}
                directors={directors}
                assignCourseToDirector={assignCourseToDirector}
                refreshDirectors={getDirectors}
                onEdit={handleEdit}
              />
            </swiper-slide>
          ))}
        </swiper-container>
      )}

      <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <Box sx={{ width: 600, height: "100vh", display: "flex", flexDirection: "column" }}>
          <Box
            sx={{
              background: 'linear-gradient(to bottom right, #9DCEE2, #7256CB)',
              color: "#fff",
              height: "80px",
              display: "flex",
              alignItems: "center",
              px: 2
            }}
          >
            <Typography variant="h6">{drawerTitle}</Typography>
          </Box>
          <Box sx={{ flex: 1, overflowY: "auto", bgcolor: "#fafafa", p: 2 }}>
            {drawerOpen && (
              <DirectorForm
                initialData={drawerData?.initialData}
                assigned={drawerData?.assigned}
                onSubmit={getDirectors}
                onClose={() => setDrawerOpen(false)}
              />
            )}
          </Box>
        </Box>
      </Drawer>

      <FloatingActionButtons onClick={handleCreate} />
    </>
  );
};

export default ListDirectors;
